import React from "react";
import { FormControl, Autocomplete as MUIAutocomplete, TextField } from "@mui/material";

const Datas = ({incluirAnoFinal, ...props}) => {
  const hoje = new Date();
  let anoAtual = hoje.getFullYear();
  let options = [];
  if(incluirAnoFinal)
    options.push(anoAtual);

  do {
    anoAtual -= 1;
    options.push(anoAtual);
  } while (2018 < anoAtual);

  return (
    <FormControl sx={{ width: 300 }}>
      <MUIAutocomplete
        id='ano'
        options={options}
        getOptionLabel={(ano) => ano.toString()}
        renderInput={(params)=><TextField {...params}
                                          label="Selecione o ano"
                               />}
        disableClearable={true}
        {...props}
      />
    </FormControl>
  );
};

export default Datas;
